import { render, staticRenderFns } from "./NotificationRegisterCard.vue?vue&type=template&id=def49af4&"
import script from "./NotificationRegisterCard.vue?vue&type=script&lang=js&"
export * from "./NotificationRegisterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports